export const AUCTION_INIT_EVENT = {
  'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
  'timestamp': 1739969798557,
  'auctionStatus': 'inProgress',
  'adUnits': [
    {
      'code': 'test-div',
      'mediaTypes': {
        'banner': {
          'sizes': [
            [
              300,
              250
            ]
          ]
        }
      },
      'bids': [
        {
          'bidder': 'appnexus',
          'params': {
            'placementId': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'liveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'liveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            }
          ]
        }
      ],
      'sizes': [
        [
          300,
          250
        ]
      ],
      'adUnitId': 'dfeffb52-99fc-4b81-b29c-2c275cd856f5',
      'transactionId': '2a3815e5-5285-415f-8d16-efdbe7eb9be5',
      'ortb2Imp': {
        'ext': {
          'tid': '2a3815e5-5285-415f-8d16-efdbe7eb9be5'
        }
      }
    },
    {
      'code': 'test-div2',
      'mediaTypes': {
        'banner': {
          'sizes': [
            [
              728,
              90
            ]
          ]
        }
      },
      'bids': [
        {
          'bidder': 'appnexus',
          'params': {
            'placementId': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'liveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'liveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            }
          ]
        }
      ],
      'sizes': [
        [
          728,
          90
        ]
      ],
      'adUnitId': '64ed0035-8f8b-49a9-956c-4d21be034175',
      'transactionId': '744fa14d-62a6-45a2-a880-c0a2a5aa6c01',
      'ortb2Imp': {
        'ext': {
          'tid': '744fa14d-62a6-45a2-a880-c0a2a5aa6c01'
        }
      }
    }
  ],
  'adUnitCodes': [
    'test-div',
    'test-div2'
  ],
  'bidderRequests': [
    {
      'bidderCode': 'appnexus',
      'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
      'bidderRequestId': '16ed05f7946bed',
      'bids': [
        {
          'bidder': 'appnexus',
          'params': {
            'placement_id': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'liveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'liveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            }
          ],
          'ortb2Imp': {
            'ext': {}
          },
          'mediaTypes': {
            'banner': {
              'sizes': [
                [
                  300,
                  250
                ]
              ]
            }
          },
          'adUnitCode': 'test-div',
          'transactionId': '2a3815e5-5285-415f-8d16-efdbe7eb9be5',
          'adUnitId': 'dfeffb52-99fc-4b81-b29c-2c275cd856f5',
          'sizes': [
            [
              300,
              250
            ]
          ],
          'bidId': '2635cc051f8d47',
          'bidderRequestId': '16ed05f7946bed',
          'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
          'src': 'client',
          'metrics': {
            'userId.init.consent': [
              0
            ],
            'userId.mod.init': [
              2.0999999940395355
            ],
            'userId.mods.liveIntentId.init': [
              2.0999999940395355
            ],
            'userId.init.modules': [
              2.2999999821186066
            ],
            'userId.callbacks.pending': [
              0
            ],
            'userId.mod.callback': [
              626.0999999940395
            ],
            'userId.mods.liveIntentId.callback': [
              626.0999999940395
            ],
            'userId.callbacks.total': [
              626.3000000119209
            ],
            'userId.total': [
              629.5999999940395
            ],
            'requestBids.userId': 623.7999999821186,
            'requestBids.validate': 0.20000001788139343,
            'requestBids.makeRequests': 1,
            'adapter.client.validate': 0.10000002384185791,
            'adapters.client.appnexus.validate': 0.10000002384185791,
            'adapter.client.buildRequests': 1.0999999940395355,
            'adapters.client.appnexus.buildRequests': 1.0999999940395355
          },
          'auctionsCount': 1,
          'bidRequestsCount': 1,
          'bidderRequestsCount': 1,
          'bidderWinsCount': 0,
          'deferBilling': false,
          'ortb2': {
            'source': {},
            'site': {
              'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
              'publisher': {
                'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com'
              },
              'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
            },
            'device': {
              'w': 3840,
              'h': 2160,
              'dnt': 1,
              'ua': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36',
              'language': 'en',
              'ext': {
                'vpw': 150,
                'vph': 1573
              },
              'sua': {
                'source': 1,
                'platform': {
                  'brand': 'macOS'
                },
                'browsers': [
                  {
                    'brand': 'Not(A:Brand',
                    'version': [
                      '99'
                    ]
                  },
                  {
                    'brand': 'Google Chrome',
                    'version': [
                      '133'
                    ]
                  },
                  {
                    'brand': 'Chromium',
                    'version': [
                      '133'
                    ]
                  }
                ],
                'mobile': 0
              }
            },
            'user': {
              'ext': {
                'eids': [
                  {
                    'source': 'liveintent.com',
                    'uids': [
                      {
                        'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                        'atype': 3
                      }
                    ]
                  },
                  {
                    'source': 'bidswitch.net',
                    'uids': [
                      {
                        'id': 'testBidswitch',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'media.net',
                    'uids': [
                      {
                        'id': 'testMadianet',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'rubiconproject.com',
                    'uids': [
                      {
                        'id': 'testMagnite',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'liveintent.sovrn.com',
                    'uids': [
                      {
                        'id': 'testSovrn',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        },
        {
          'bidder': 'appnexus',
          'params': {
            'placement_id': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'liveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'liveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'liveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'liveintent.com'
                  }
                }
              ]
            }
          ],
          'ortb2Imp': {
            'ext': {}
          },
          'mediaTypes': {
            'banner': {
              'sizes': [
                [
                  728,
                  90
                ]
              ]
            }
          },
          'adUnitCode': 'test-div2',
          'transactionId': '744fa14d-62a6-45a2-a880-c0a2a5aa6c01',
          'adUnitId': '64ed0035-8f8b-49a9-956c-4d21be034175',
          'sizes': [
            [
              728,
              90
            ]
          ],
          'bidId': '39ca9c9224aa1a',
          'bidderRequestId': '16ed05f7946bed',
          'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
          'src': 'client',
          'metrics': {
            'userId.init.consent': [
              0
            ],
            'userId.mod.init': [
              2.0999999940395355
            ],
            'userId.mods.liveIntentId.init': [
              2.0999999940395355
            ],
            'userId.init.modules': [
              2.2999999821186066
            ],
            'userId.callbacks.pending': [
              0
            ],
            'userId.mod.callback': [
              626.0999999940395
            ],
            'userId.mods.liveIntentId.callback': [
              626.0999999940395
            ],
            'userId.callbacks.total': [
              626.3000000119209
            ],
            'userId.total': [
              629.5999999940395
            ],
            'requestBids.userId': 623.7999999821186,
            'requestBids.validate': 0.20000001788139343,
            'requestBids.makeRequests': 1,
            'adapter.client.validate': 0.10000002384185791,
            'adapters.client.appnexus.validate': 0.10000002384185791,
            'adapter.client.buildRequests': 1.0999999940395355,
            'adapters.client.appnexus.buildRequests': 1.0999999940395355
          },
          'auctionsCount': 1,
          'bidRequestsCount': 1,
          'bidderRequestsCount': 1,
          'bidderWinsCount': 0,
          'deferBilling': false,
          'ortb2': {
            'source': {},
            'site': {
              'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
              'publisher': {
                'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com'
              },
              'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
            },
            'device': {
              'w': 3840,
              'h': 2160,
              'dnt': 1,
              'ua': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36',
              'language': 'en',
              'ext': {
                'vpw': 150,
                'vph': 1573
              },
              'sua': {
                'source': 1,
                'platform': {
                  'brand': 'macOS'
                },
                'browsers': [
                  {
                    'brand': 'Not(A:Brand',
                    'version': [
                      '99'
                    ]
                  },
                  {
                    'brand': 'Google Chrome',
                    'version': [
                      '133'
                    ]
                  },
                  {
                    'brand': 'Chromium',
                    'version': [
                      '133'
                    ]
                  }
                ],
                'mobile': 0
              }
            },
            'user': {
              'ext': {
                'eids': [
                  {
                    'source': 'liveintent.com',
                    'uids': [
                      {
                        'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                        'atype': 3
                      }
                    ]
                  },
                  {
                    'source': 'bidswitch.net',
                    'uids': [
                      {
                        'id': 'testBidswitch',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'media.net',
                    'uids': [
                      {
                        'id': 'testMadianet',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'rubiconproject.com',
                    'uids': [
                      {
                        'id': 'testMagnite',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'liveintent.sovrn.com',
                    'uids': [
                      {
                        'id': 'testSovrn',
                        'atype': 3,
                        'ext': {
                          'provider': 'liveintent.com'
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        }
      ],
      'auctionStart': 1739969798557,
      'timeout': 2000,
      'refererInfo': {
        'reachedTop': true,
        'isAmp': false,
        'numIframes': 0,
        'stack': [
          'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
        ],
        'topmostLocation': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
        'location': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
        'canonicalUrl': null,
        'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
        'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
        'ref': null,
        'legacy': {
          'reachedTop': true,
          'isAmp': false,
          'numIframes': 0,
          'stack': [
            'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
          ],
          'referer': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
          'canonicalUrl': null
        }
      },
      'metrics': {
        'userId.init.consent': [
          0
        ],
        'userId.mod.init': [
          2.0999999940395355
        ],
        'userId.mods.liveIntentId.init': [
          2.0999999940395355
        ],
        'userId.init.modules': [
          2.2999999821186066
        ],
        'userId.callbacks.pending': [
          0
        ],
        'userId.mod.callback': [
          626.0999999940395
        ],
        'userId.mods.liveIntentId.callback': [
          626.0999999940395
        ],
        'userId.callbacks.total': [
          626.3000000119209
        ],
        'userId.total': [
          629.5999999940395
        ],
        'requestBids.userId': 623.7999999821186,
        'requestBids.validate': 0.20000001788139343,
        'requestBids.makeRequests': 1,
        'adapter.client.validate': 0.10000002384185791,
        'adapters.client.appnexus.validate': 0.10000002384185791,
        'adapter.client.buildRequests': 1.0999999940395355,
        'adapters.client.appnexus.buildRequests': 1.0999999940395355
      },
      'ortb2': {
        'source': {},
        'site': {
          'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
          'publisher': {
            'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com'
          },
          'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
        },
        'device': {
          'w': 3840,
          'h': 2160,
          'dnt': 1,
          'ua': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36',
          'language': 'en',
          'ext': {
            'vpw': 150,
            'vph': 1573
          },
          'sua': {
            'source': 1,
            'platform': {
              'brand': 'macOS'
            },
            'browsers': [
              {
                'brand': 'Not(A:Brand',
                'version': [
                  '99'
                ]
              },
              {
                'brand': 'Google Chrome',
                'version': [
                  '133'
                ]
              },
              {
                'brand': 'Chromium',
                'version': [
                  '133'
                ]
              }
            ],
            'mobile': 0
          }
        },
        'user': {
          'ext': {
            'eids': [
              {
                'source': 'liveintent.com',
                'uids': [
                  {
                    'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                    'atype': 3
                  }
                ]
              },
              {
                'source': 'bidswitch.net',
                'uids': [
                  {
                    'id': 'testBidswitch',
                    'atype': 3,
                    'ext': {
                      'provider': 'liveintent.com'
                    }
                  }
                ]
              },
              {
                'source': 'media.net',
                'uids': [
                  {
                    'id': 'testMadianet',
                    'atype': 3,
                    'ext': {
                      'provider': 'liveintent.com'
                    }
                  }
                ]
              },
              {
                'source': 'rubiconproject.com',
                'uids': [
                  {
                    'id': 'testMagnite',
                    'atype': 3,
                    'ext': {
                      'provider': 'liveintent.com'
                    }
                  }
                ]
              },
              {
                'source': 'liveintent.sovrn.com',
                'uids': [
                  {
                    'id': 'testSovrn',
                    'atype': 3,
                    'ext': {
                      'provider': 'liveintent.com'
                    }
                  }
                ]
              }
            ]
          }
        }
      },
      'start': 1739969798558
    }
  ],
  'noBids': [],
  'bidsReceived': [],
  'bidsRejected': [],
  'winningBids': [],
  'timeout': 2000,
  'metrics': {
    'userId.init.consent': [
      0
    ],
    'userId.mod.init': [
      2.0999999940395355
    ],
    'userId.mods.liveIntentId.init': [
      2.0999999940395355
    ],
    'userId.init.modules': [
      2.2999999821186066
    ],
    'userId.callbacks.pending': [
      0
    ],
    'userId.mod.callback': [
      626.0999999940395
    ],
    'userId.mods.liveIntentId.callback': [
      626.0999999940395
    ],
    'userId.callbacks.total': [
      626.3000000119209
    ],
    'userId.total': [
      629.5999999940395
    ],
    'adapter.client.validate': [
      0.10000002384185791
    ],
    'adapters.client.appnexus.validate': [
      0.10000002384185791
    ],
    'adapter.client.buildRequests': [
      1.0999999940395355
    ],
    'adapters.client.appnexus.buildRequests': [
      1.0999999940395355
    ],
    'requestBids.userId': 623.7999999821186,
    'requestBids.validate': 0.20000001788139343,
    'requestBids.makeRequests': 1
  },
  'seatNonBids': []
}

export const AUCTION_INIT_EVENT_NOT_LI = {
  'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
  'timestamp': 1739969798557,
  'auctionStatus': 'inProgress',
  'adUnits': [
    {
      'code': 'test-div',
      'mediaTypes': {
        'banner': {
          'sizes': [
            [
              300,
              250
            ]
          ]
        }
      },
      'bids': [
        {
          'bidder': 'appnexus',
          'params': {
            'placementId': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'NOTNOTliveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'NOTliveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            }
          ]
        }
      ],
      'sizes': [
        [
          300,
          250
        ]
      ],
      'adUnitId': 'dfeffb52-99fc-4b81-b29c-2c275cd856f5',
      'transactionId': '2a3815e5-5285-415f-8d16-efdbe7eb9be5',
      'ortb2Imp': {
        'ext': {
          'tid': '2a3815e5-5285-415f-8d16-efdbe7eb9be5'
        }
      }
    },
    {
      'code': 'test-div2',
      'mediaTypes': {
        'banner': {
          'sizes': [
            [
              728,
              90
            ]
          ]
        }
      },
      'bids': [
        {
          'bidder': 'appnexus',
          'params': {
            'placementId': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'NOTliveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            }
          ]
        }
      ],
      'sizes': [
        [
          728,
          90
        ]
      ],
      'adUnitId': '64ed0035-8f8b-49a9-956c-4d21be034175',
      'transactionId': '744fa14d-62a6-45a2-a880-c0a2a5aa6c01',
      'ortb2Imp': {
        'ext': {
          'tid': '744fa14d-62a6-45a2-a880-c0a2a5aa6c01'
        }
      }
    }
  ],
  'adUnitCodes': [
    'test-div',
    'test-div2'
  ],
  'bidderRequests': [
    {
      'bidderCode': 'appnexus',
      'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
      'bidderRequestId': '16ed05f7946bed',
      'bids': [
        {
          'bidder': 'appnexus',
          'params': {
            'placement_id': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'NOTliveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            }
          ],
          'ortb2Imp': {
            'ext': {}
          },
          'mediaTypes': {
            'banner': {
              'sizes': [
                [
                  300,
                  250
                ]
              ]
            }
          },
          'adUnitCode': 'test-div',
          'transactionId': '2a3815e5-5285-415f-8d16-efdbe7eb9be5',
          'adUnitId': 'dfeffb52-99fc-4b81-b29c-2c275cd856f5',
          'sizes': [
            [
              300,
              250
            ]
          ],
          'bidId': '2635cc051f8d47',
          'bidderRequestId': '16ed05f7946bed',
          'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
          'src': 'client',
          'metrics': {
            'userId.init.consent': [
              0
            ],
            'userId.mod.init': [
              2.0999999940395355
            ],
            'userId.mods.liveIntentId.init': [
              2.0999999940395355
            ],
            'userId.init.modules': [
              2.2999999821186066
            ],
            'userId.callbacks.pending': [
              0
            ],
            'userId.mod.callback': [
              626.0999999940395
            ],
            'userId.mods.liveIntentId.callback': [
              626.0999999940395
            ],
            'userId.callbacks.total': [
              626.3000000119209
            ],
            'userId.total': [
              629.5999999940395
            ],
            'requestBids.userId': 623.7999999821186,
            'requestBids.validate': 0.20000001788139343,
            'requestBids.makeRequests': 1,
            'adapter.client.validate': 0.10000002384185791,
            'adapters.client.appnexus.validate': 0.10000002384185791,
            'adapter.client.buildRequests': 1.0999999940395355,
            'adapters.client.appnexus.buildRequests': 1.0999999940395355
          },
          'auctionsCount': 1,
          'bidRequestsCount': 1,
          'bidderRequestsCount': 1,
          'bidderWinsCount': 0,
          'deferBilling': false,
          'ortb2': {
            'source': {},
            'site': {
              'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
              'publisher': {
                'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com'
              },
              'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
            },
            'device': {
              'w': 3840,
              'h': 2160,
              'dnt': 1,
              'ua': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36',
              'language': 'en',
              'ext': {
                'vpw': 150,
                'vph': 1573
              },
              'sua': {
                'source': 1,
                'platform': {
                  'brand': 'macOS'
                },
                'browsers': [
                  {
                    'brand': 'Not(A:Brand',
                    'version': [
                      '99'
                    ]
                  },
                  {
                    'brand': 'Google Chrome',
                    'version': [
                      '133'
                    ]
                  },
                  {
                    'brand': 'Chromium',
                    'version': [
                      '133'
                    ]
                  }
                ],
                'mobile': 0
              }
            },
            'user': {
              'ext': {
                'eids': [
                  {
                    'source': 'NOTliveintent.com',
                    'uids': [
                      {
                        'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                        'atype': 3
                      }
                    ]
                  },
                  {
                    'source': 'bidswitch.net',
                    'uids': [
                      {
                        'id': 'testBidswitch',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'media.net',
                    'uids': [
                      {
                        'id': 'testMadianet',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'rubiconproject.com',
                    'uids': [
                      {
                        'id': 'testMagnite',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'liveintent.sovrn.com',
                    'uids': [
                      {
                        'id': 'testSovrn',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        },
        {
          'bidder': 'appnexus',
          'params': {
            'placement_id': 13144370
          },
          'userId': {
            'lipb': {
              'nonId': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
              'sovrn': 'testSovrn',
              'medianet': 'testMadianet',
              'bidswitch': 'testBidswitch',
              'magnite': 'testMagnite',
              'lipbid': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg=='
            },
            'bidswitch': {
              'id': 'testBidswitch',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'medianet': {
              'id': 'testMadianet',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'magnite': {
              'id': 'testMagnite',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            },
            'sovrn': {
              'id': 'testSovrn',
              'ext': {
                'provider': 'NOTliveintent.com'
              }
            }
          },
          'userIdAsEids': [
            {
              'source': 'NOTliveintent.com',
              'uids': [
                {
                  'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                  'atype': 3
                }
              ]
            },
            {
              'source': 'bidswitch.net',
              'uids': [
                {
                  'id': 'testBidswitch',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'media.net',
              'uids': [
                {
                  'id': 'testMadianet',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'rubiconproject.com',
              'uids': [
                {
                  'id': 'testMagnite',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            },
            {
              'source': 'liveintent.sovrn.com',
              'uids': [
                {
                  'id': 'testSovrn',
                  'atype': 3,
                  'ext': {
                    'provider': 'NOTliveintent.com'
                  }
                }
              ]
            }
          ],
          'ortb2Imp': {
            'ext': {}
          },
          'mediaTypes': {
            'banner': {
              'sizes': [
                [
                  728,
                  90
                ]
              ]
            }
          },
          'adUnitCode': 'test-div2',
          'transactionId': '744fa14d-62a6-45a2-a880-c0a2a5aa6c01',
          'adUnitId': '64ed0035-8f8b-49a9-956c-4d21be034175',
          'sizes': [
            [
              728,
              90
            ]
          ],
          'bidId': '39ca9c9224aa1a',
          'bidderRequestId': '16ed05f7946bed',
          'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
          'src': 'client',
          'metrics': {
            'userId.init.consent': [
              0
            ],
            'userId.mod.init': [
              2.0999999940395355
            ],
            'userId.mods.liveIntentId.init': [
              2.0999999940395355
            ],
            'userId.init.modules': [
              2.2999999821186066
            ],
            'userId.callbacks.pending': [
              0
            ],
            'userId.mod.callback': [
              626.0999999940395
            ],
            'userId.mods.liveIntentId.callback': [
              626.0999999940395
            ],
            'userId.callbacks.total': [
              626.3000000119209
            ],
            'userId.total': [
              629.5999999940395
            ],
            'requestBids.userId': 623.7999999821186,
            'requestBids.validate': 0.20000001788139343,
            'requestBids.makeRequests': 1,
            'adapter.client.validate': 0.10000002384185791,
            'adapters.client.appnexus.validate': 0.10000002384185791,
            'adapter.client.buildRequests': 1.0999999940395355,
            'adapters.client.appnexus.buildRequests': 1.0999999940395355
          },
          'auctionsCount': 1,
          'bidRequestsCount': 1,
          'bidderRequestsCount': 1,
          'bidderWinsCount': 0,
          'deferBilling': false,
          'ortb2': {
            'source': {},
            'site': {
              'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
              'publisher': {
                'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com'
              },
              'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
            },
            'device': {
              'w': 3840,
              'h': 2160,
              'dnt': 1,
              'ua': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36',
              'language': 'en',
              'ext': {
                'vpw': 150,
                'vph': 1573
              },
              'sua': {
                'source': 1,
                'platform': {
                  'brand': 'macOS'
                },
                'browsers': [
                  {
                    'brand': 'Not(A:Brand',
                    'version': [
                      '99'
                    ]
                  },
                  {
                    'brand': 'Google Chrome',
                    'version': [
                      '133'
                    ]
                  },
                  {
                    'brand': 'Chromium',
                    'version': [
                      '133'
                    ]
                  }
                ],
                'mobile': 0
              }
            },
            'user': {
              'ext': {
                'eids': [
                  {
                    'source': 'NOTliveintent.com',
                    'uids': [
                      {
                        'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                        'atype': 3
                      }
                    ]
                  },
                  {
                    'source': 'bidswitch.net',
                    'uids': [
                      {
                        'id': 'testBidswitch',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'media.net',
                    'uids': [
                      {
                        'id': 'testMadianet',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'rubiconproject.com',
                    'uids': [
                      {
                        'id': 'testMagnite',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  },
                  {
                    'source': 'liveintent.sovrn.com',
                    'uids': [
                      {
                        'id': 'testSovrn',
                        'atype': 3,
                        'ext': {
                          'provider': 'NOTliveintent.com'
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        }
      ],
      'auctionStart': 1739969798557,
      'timeout': 2000,
      'refererInfo': {
        'reachedTop': true,
        'isAmp': false,
        'numIframes': 0,
        'stack': [
          'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
        ],
        'topmostLocation': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
        'location': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
        'canonicalUrl': null,
        'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
        'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
        'ref': null,
        'legacy': {
          'reachedTop': true,
          'isAmp': false,
          'numIframes': 0,
          'stack': [
            'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
          ],
          'referer': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html',
          'canonicalUrl': null
        }
      },
      'metrics': {
        'userId.init.consent': [
          0
        ],
        'userId.mod.init': [
          2.0999999940395355
        ],
        'userId.mods.liveIntentId.init': [
          2.0999999940395355
        ],
        'userId.init.modules': [
          2.2999999821186066
        ],
        'userId.callbacks.pending': [
          0
        ],
        'userId.mod.callback': [
          626.0999999940395
        ],
        'userId.mods.liveIntentId.callback': [
          626.0999999940395
        ],
        'userId.callbacks.total': [
          626.3000000119209
        ],
        'userId.total': [
          629.5999999940395
        ],
        'requestBids.userId': 623.7999999821186,
        'requestBids.validate': 0.20000001788139343,
        'requestBids.makeRequests': 1,
        'adapter.client.validate': 0.10000002384185791,
        'adapters.client.appnexus.validate': 0.10000002384185791,
        'adapter.client.buildRequests': 1.0999999940395355,
        'adapters.client.appnexus.buildRequests': 1.0999999940395355
      },
      'ortb2': {
        'source': {},
        'site': {
          'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com',
          'publisher': {
            'domain': 'vdreiling-lab-test.s3.us-east-1.amazonaws.com'
          },
          'page': 'https://vdreiling-lab-test.s3.us-east-1.amazonaws.com/prebid-presentation/pageWith2.html'
        },
        'device': {
          'w': 3840,
          'h': 2160,
          'dnt': 1,
          'ua': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.0.0 Safari/537.36',
          'language': 'en',
          'ext': {
            'vpw': 150,
            'vph': 1573
          },
          'sua': {
            'source': 1,
            'platform': {
              'brand': 'macOS'
            },
            'browsers': [
              {
                'brand': 'Not(A:Brand',
                'version': [
                  '99'
                ]
              },
              {
                'brand': 'Google Chrome',
                'version': [
                  '133'
                ]
              },
              {
                'brand': 'Chromium',
                'version': [
                  '133'
                ]
              }
            ],
            'mobile': 0
          }
        },
        'user': {
          'ext': {
            'eids': [
              {
                'source': 'NOTliveintent.com',
                'uids': [
                  {
                    'id': '12-hMaZCgZ9Q99h3cGDam21dEfxTawgIafx1J1zxvXTHwnrXUHWudCwcgIjkbTbZpRd2DV9ivSyz2L9t27VTNWXYAvYmk82zmrmciW71dSFq00zHg==',
                    'atype': 3
                  }
                ]
              },
              {
                'source': 'bidswitch.net',
                'uids': [
                  {
                    'id': 'testBidswitch',
                    'atype': 3,
                    'ext': {
                      'provider': 'NOTliveintent.com'
                    }
                  }
                ]
              },
              {
                'source': 'media.net',
                'uids': [
                  {
                    'id': 'testMadianet',
                    'atype': 3,
                    'ext': {
                      'provider': 'NOTliveintent.com'
                    }
                  }
                ]
              },
              {
                'source': 'rubiconproject.com',
                'uids': [
                  {
                    'id': 'testMagnite',
                    'atype': 3,
                    'ext': {
                      'provider': 'NOTliveintent.com'
                    }
                  }
                ]
              },
              {
                'source': 'liveintent.sovrn.com',
                'uids': [
                  {
                    'id': 'testSovrn',
                    'atype': 3,
                    'ext': {
                      'provider': 'NOTliveintent.com'
                    }
                  }
                ]
              }
            ]
          }
        }
      },
      'start': 1739969798558
    }
  ],
  'noBids': [],
  'bidsReceived': [],
  'bidsRejected': [],
  'winningBids': [],
  'timeout': 2000,
  'metrics': {
    'userId.init.consent': [
      0
    ],
    'userId.mod.init': [
      2.0999999940395355
    ],
    'userId.mods.liveIntentId.init': [
      2.0999999940395355
    ],
    'userId.init.modules': [
      2.2999999821186066
    ],
    'userId.callbacks.pending': [
      0
    ],
    'userId.mod.callback': [
      626.0999999940395
    ],
    'userId.mods.liveIntentId.callback': [
      626.0999999940395
    ],
    'userId.callbacks.total': [
      626.3000000119209
    ],
    'userId.total': [
      629.5999999940395
    ],
    'adapter.client.validate': [
      0.10000002384185791
    ],
    'adapters.client.appnexus.validate': [
      0.10000002384185791
    ],
    'adapter.client.buildRequests': [
      1.0999999940395355
    ],
    'adapters.client.appnexus.buildRequests': [
      1.0999999940395355
    ],
    'requestBids.userId': 623.7999999821186,
    'requestBids.validate': 0.20000001788139343,
    'requestBids.makeRequests': 1
  },
  'seatNonBids': []
}

export const BID_WON_EVENT = {
  'bidderCode': 'appnexus',
  'width': 728,
  'height': 90,
  'statusMessage': 'Bid available',
  'adId': '4e02072b881823',
  'requestId': '3fae2718fd70f',
  'transactionId': '6daa1dac-9eea-47ce-82ce-ce9681df1ec5',
  'adUnitId': 'afc6bc6a-3082-4940-b37f-d22e1b026e48',
  'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
  'mediaType': 'banner',
  'source': 'client',
  'cpm': 1.5,
  'creativeId': 98493734,
  'currency': 'USD',
  'netRevenue': true,
  'ttl': 300,
  'adUnitCode': 'test-div2',
  'appnexus': {
    'buyerMemberId': 9325
  },
  'meta': {
    'advertiserId': 2529885,
    'dchain': {
      'ver': '1.0',
      'complete': 0,
      'nodes': [
        {
          'bsid': '9325'
        }
      ]
    },
    'brandId': 555545
  },
  'ad': "<!-- Creative 98493734 served by Member 9325 via AppNexus --><a href=\"https://fra1-ib.adnxs.com/click2?e=wqT_3QKfAfBtnwAAAAMAxBkFAQjLtNe9BhCkr-mSn9zTvwsYh6Pop7Cy0rQSILKiogYo7Ugw7Ug4AkCmyvsuSJzxW1AAWgNVU0RiA1VTRGjYBXBaeLXPeYABstgFiAEBkAEBmAEDoAECqQEAAAAAAAD4P7EBAAABDDD4P7kBAAAAwPUo-D_BAQoAAAEeAMkVCjDYAQDgAQDwAfUv-AEA/s=6676f8c324bf37b4366612bef92c11edbe7356f1/bcr=AAAAAAAA8D8=/cnd=%21uBDL_QjKvJodEKbK-y4YnPFbIAQoADEAAAAAAAD4PzoJRlJBMTo1Njg5QMtISQAAAAAAAPA_UQAAAAAAAAAAWQAAAAAAAAAAYQAAAAAAAAAAaQAAAAAAAAAAcQAAAAAAAAAAeACJAQAAAAAAAAAA/cca=OTMyNSNGUkExOjU2ODk=/bn=93234/clickenc=https%3A%2F%2Fdocs.prebid.org%2Fdev-docs%2Fgetting-started.html\" target=\"_blank\"><img width=\"728\" height=\"90\" style=\"border-style: none\" src=\"https://vcdn.adnxs.com/p/creative-image/f6/11/33/19/f6113319-e789-4408-b69d-b178d60c5a6e.png\" /></a><iframe src=\"https://acdn.adnxs.com/dmp/async_usersync.html?gdpr=0&seller_id=9325&pub_id=1193043\" width=\"1\" height=\"1\" frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" topmargin=\"0\" leftmargin=\"0\" style=\"position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0;\"></iframe><script>try {!function(){function e(e,t){return\"function\"==typeof __an_obj_extend_thunk?__an_obj_extend_thunk(e,t):e}function t(e,t){\"function\"==typeof __an_err_thunk&&__an_err_thunk(e,t)}function n(e,t){if(\"function\"==typeof __an_redirect_thunk)__an_redirect_thunk(e);else{var n=navigator.connection;navigator.__an_connection&&(n=navigator.__an_connection),window==window.top&&n&&n.downlinkMax<=.115&&\"function\"==typeof HTMLIFrameElement&&HTMLIFrameElement.prototype.hasOwnProperty(\"srcdoc\")?(window.__an_resize=function(e,t,n){var r=e.frameElement;r&&\"__an_if\"==r.getAttribute(\"name\")&&(t&&(r.style.width=t+\"px\"),n&&(r.style.height=n+\"px\"))},document.write('<iframe name=\"__an_if\" style=\"width:0;height:0\" srcdoc=\"<script type=\\'text/javascript\\' src=\\''+e+\"&\"+t.bdfif+\"=1'></sc\"),document.write('ript>\" frameborder=\"0\" scrolling=\"no\" marginheight=0 marginwidth=0 topmargin=\"0\" leftmargin=\"0\" allowtransparency=\"true\"></iframe>')):document.write('<script language=\"javascript\" src=\"'+e+'\"></scr'+'ipt>')}};var r=function(e){this.rdParams=e};r.prototype={constructor:r,walkAncestors:function(e){try{if(!window.location.ancestorOrigins)return;for(var t=0,n=window.location.ancestorOrigins.length;n>t;t++)e.call(null,window.location.ancestorOrigins[t],t)}catch(r){\"undefined\"!=typeof console}return[]},walkUpWindows:function(e){var t,n=[];do try{t=t?t.parent:window,e.call(null,t,n)}catch(r){return\"undefined\"!=typeof console,n.push({referrer:null,location:null,isTop:!1}),n}while(t!=window.top);return n},getPubUrlStack:function(e){var n,r=[],o=null,i=null,a=null,c=null,d=null,s=null,u=null;for(n=e.length-1;n>=0;n--){try{a=e[n].location}catch(l){\"undefined\"!=typeof console,t(l,\"AnRDModule::getPubUrlStack:: location\")}if(a)i=encodeURIComponent(a),r.push(i),u||(u=i);else if(0!==n){c=e[n-1];try{d=c.referrer,s=c.ancestor}catch(l){\"undefined\"!=typeof console,t(l,\"AnRDModule::getPubUrlStack:: prevFrame\")}d?(i=encodeURIComponent(d),r.push(i),u||(u=i)):s?(i=encodeURIComponent(s),r.push(i),u||(u=i)):r.push(o)}else r.push(o)}return{stack:r,detectUrl:u}},getLevels:function(){var e=this.walkUpWindows(function(e,n){try{n.push({referrer:e.document.referrer||null,location:e.location.href||null,isTop:e==window.top})}catch(r){n.push({referrer:null,location:null,isTop:e==window.top}),\"undefined\"!=typeof console,t(r,\"AnRDModule::getLevels\")}});return this.walkAncestors(function(t,n){e[n].ancestor=t}),e},getRefererInfo:function(){var e=\"\";try{var n=this.getLevels(),r=n.length-1,o=null!==n[r].location||r>0&&null!==n[r-1].referrer,i=this.getPubUrlStack(n);e=this.rdParams.rdRef+\"=\"+i.detectUrl+\"&\"+this.rdParams.rdTop+\"=\"+o+\"&\"+this.rdParams.rdIfs+\"=\"+r+\"&\"+this.rdParams.rdStk+\"=\"+i.stack+\"&\"+decodeURI(this.rdParams.rdQs)}catch(a){e=\"\",\"undefined\"!=typeof console,t(a,\"AnRDModule::getRefererInfo\")}return e}};var o=function(n){var o=\"\";try{n=e(n,0);var i=e(new r(n),1);return i.getRefererInfo()}catch(a){o=\"\",\"undefined\"!=typeof console,t(a,\"AnRDModule::executeRD\")}return o};;var c=\"https://fra1-ib.adnxs.com/rd_log?an_audit=0&referrer=https%3A%2F%2Fvdreiling-lab-test.s3.us-east-1.amazonaws.com%2Fprebid-presentation%2FpageWith2.html&e=wqT_3QL4DqB4BwAAAwDWAAUBCMu0170GEKSv6ZKf3NO_CxiHo-insLLStBIqNgkAAAECCPg_EQEHNAAA-D8ZAAAAwPUo-D8hERIAKREJADERG6gwsqKiBjjtSEDtSEgCUKbK-y5YnPFbYABotc95eLLYBYABAYoBA1VTRJIBAQbgmAHYBaABWqgBAbABALgBAcABA8gBAtABANgBAOABAPABAIoCKXVmKCdhJywgMjUyOTg4NSwgMCk7ARQwcicsIDk4NDkzNzM0LAEV8P2SArkEIWdHWkdOQWpLdkpvZEVLYksteTRZQUNDYzhWc3dBRGdBUUFSSTdVaFFzcUtpQmxnQVlPOEJhQUJ3SG5nZWdBRXVpQUVla0FFQm1BRUJvQUVCcUFFRHNBRUF1UUctMEV6RkFBRDRQOEVCdnRCTXhRQUEtRF9KQVh2RGw4S1c5LWtfMlFFQUFBQUFBQUR3UC1BQkFQVUJBQUFBQUpnQ0FLQUNBTFVDQUFBQUFMMENBQUFBQU1BQ0FNZ0NBTkFDQU5nQ0FPQUNBT2dDQVBnQ0FJQURBWmdEQWJvRENVWlNRVEU2TlRZNE9lQUR5MGlJQkFDUUJBQ1lCQUhCQgVNCQEIeVFRCQkBARROZ0VBUEURlSxBQUFDSUJia3NxUVUBDQmoCDdFRgEKCQEIREJCHT8AeRUoDEFBQU4yKAAAWi4oAPBlNEFYd2t3bnFCU1lJQkJJaUFBQUVHaXVpMDIwUjBQTVFldUxka0Rha19yMmI3VWFsX3MtZUlTM3FFRmx3bV9BRjdmemFBdmdGM2JTYUFZSUdBMVZUUklnR0FKQUdBWmdHQUtFR0FBAYU0QUEtRC1vQmdHeUJpUUoJEgUBAFIFBgkBAFoJBwUBAGgFBgUBGEM0QmdxQkMFDAkBSGlBZ0FrQWdBmgKVASF1QkRMX1E2PQIkblBGYklBUW9BRDFEWEQ0UHpvSlJsSkJNVG8xTmpnNVFNdElTMTUMUEFfVREMDEFBQVcdDABZHQwAYR0MAGMdDBBlQUNKQR0QeMICNWh0dHBzOi8vZG9jcy5wcmViaWQub3JnL2Rldi0BFIgvZ2V0dGluZy1zdGFydGVkLmh0bWzYAvfpA-ACrZhI6gJYaA1CFHZkcmVpbAErkGxhYi10ZXN0LnMzLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL3AFa1gtcHJlc2VudGF0aW9uL3BhZ2VXaXRoMgVlMPICEQoGQURWX0lEEgdtoQUUCENQRwUUFDU2ODQ4NAUUCAVDUAETNAg2MTI1MTE0NvICDgoIATxoRlJFURICMjPyAg0KCFJFTV9VU0VSEgEw8gIMCSEUQ09ERRIABQ8BWBEPEAsKB0NQFQ4QCQoFSU8BYQQA8gEaBElPFRo4EwoPQ1VTVE9NX01PREVMDSQIGgoWMhYAHExFQUZfTkFNBWoIHgoaNh0ACEFTVAE-EElGSUVEAWIcDQoIU1BMSVQBTdABMIADAIgDAZADAJgDF6ADAaoDAMAD2ATIAwDYA76sAuADAOgDAPgDAYAEAJIEDS91dC92My1d8H2YBACiBAw5MS45Ni42OC4xNzioBOfJB7IEEwgEEAQY2AUgWigBKAIwADgCQgC4BADABIDauCLIBADSBA45MzI1I0ZSQTE6NTY4OdoEAggB4AQB8ASmyvsuiAUBmAUAoAX___________8BwAUAyQUAAAAAAADwP9IFCQkAAAClwHDYBQHgBQHwBZn0IfoFBAgAEACQBgCYBgC4BgDBBgUiLADwP9AG9S_aBhYKEAkRGQFwEAAYAOAGAfIGAggAgAcBiAcAoAcByAey2AXSBw8VZAEmECAA2gcGAV_w9hgA4AcA6gcCCADwB_maAYoIwgEKvQEAAAGVHly0-At_TuHyWlekBSbXDsn7MA9kiN8zpQ3JU8nyaO8zDdp7eXakZns5iCya3WWSR84RbuXAFW3-XwQJeVDN6TyG7YPNRXX4XdmMcWX9_1-QRFJpDfa-JbkkC7fYcZAqd8ZtVFwqslqguelw0STCq4BqBFk4FzPd-AeWHANk_mkOfwp6MpZue28Vux_gDUVUgG02dxjB3K6zennqYPc7saGU_2WRWY3DmLT5qRojJ63yZx_ce2dwxwsQAZUIAACAP5gIAcAIANIIBggAEAAYANoIBAgAIADgCADoCAA.&s=85d0e398f1a637f01e83f3a42d8ad7d3bf45b8ac\";c+=\"&\"+o({rdRef:\"bdref\",rdTop:\"bdtop\",rdIfs:\"bdifs\",rdStk:\"bstk\",rdQs:\"\"}),n(c,{bdfif:\"bdfif\"})}();} catch (e) { }</script><div name=\"anxv\" lnttag=\"v;tv=view7-1hs;st=0;d=728x90;vc=iab;vid_ccr=1;tag_id=13144370;cb=https%3A%2F%2Ffra1-ib.adnxs.com%2Fvevent%3Fan_audit%3D0%26referrer%3Dhttps%253A%252F%252Fvdreiling-lab-test.s3.us-east-1.amazonaws.com%252Fprebid-presentation%252FpageWith2.html%26e%3DwqT_3QL5DKB5BgAAAwDWAAUBCMu0170GEKSv6ZKf3NO_CxiHo-insLLStBIqNgkAAAECCPg_EQEHNAAA-D8ZAAAAwPUo-D8hERIAKREJADERG6gwsqKiBjjtSEDtSEgCUKbK-y5YnPFbYABotc95eLLYBYABAYoBA1VTRJIBAQbgmAHYBaABWqgBAbABALgBAcABA8gBAtABANgBAOABAPABAIoCKXVmKCdhJywgMjUyOTg4NSwgMCk7ARQwcicsIDk4NDkzNzM0LAEV8P2SArkEIWdHWkdOQWpLdkpvZEVLYksteTRZQUNDYzhWc3dBRGdBUUFSSTdVaFFzcUtpQmxnQVlPOEJhQUJ3SG5nZWdBRXVpQUVla0FFQm1BRUJvQUVCcUFFRHNBRUF1UUctMEV6RkFBRDRQOEVCdnRCTXhRQUEtRF9KQVh2RGw4S1c5LWtfMlFFQUFBQUFBQUR3UC1BQkFQVUJBQUFBQUpnQ0FLQUNBTFVDQUFBQUFMMENBQUFBQU1BQ0FNZ0NBTkFDQU5nQ0FPQUNBT2dDQVBnQ0FJQURBWmdEQWJvRENVWlNRVEU2TlRZNE9lQUR5MGlJQkFDUUJBQ1lCQUhCQgVNCQEIeVFRCQkBARROZ0VBUEURlSxBQUFDSUJia3NxUVUBDQmoCDdFRgEKCQEIREJCHT8AeRUoDEFBQU4yKAAAWi4oAPBlNEFYd2t3bnFCU1lJQkJJaUFBQUVHaXVpMDIwUjBQTVFldUxka0Rha19yMmI3VWFsX3MtZUlTM3FFRmx3bV9BRjdmemFBdmdGM2JTYUFZSUdBMVZUUklnR0FKQUdBWmdHQUtFR0FBAYU0QUEtRC1vQmdHeUJpUUoJEgUBAFIFBgkBAFoJBwUBAGgFBgUBGEM0QmdxQkMFDAkBSGlBZ0FrQWdBmgKVASF1QkRMX1E2PQIkblBGYklBUW9BRDFEWEQ0UHpvSlJsSkJNVG8xTmpnNVFNdElTMTUMUEFfVREMDEFBQVcdDABZHQwAYR0MAGMdDBBlQUNKQR0QeMICNWh0dHBzOi8vZG9jcy5wcmViaWQub3JnL2Rldi0BFIgvZ2V0dGluZy1zdGFydGVkLmh0bWzYAvfpA-ACrZhI6gJYaA1CFHZkcmVpbAErkGxhYi10ZXN0LnMzLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL3AFa1gtcHJlc2VudGF0aW9uL3BhZ2VXaXRoMgVlyIADAIgDAZADAJgDF6ADAaoDAMAD2ATIAwDYA76sAuADAOgDAPgDAYAEAJIEDS91dC92Mw1W8H2YBACiBAw5MS45Ni42OC4xNzioBOfJB7IEEwgEEAQY2AUgWigBKAIwADgCQgC4BADABIDauCLIBADSBA45MzI1I0ZSQTE6NTY4OdoEAggB4AQB8ASmyvsuiAUBmAUAoAX___________8BwAUAyQUAAAAAAADwP9IFCQkAAACFuXDYBQHgBQHwBZn0IfoFBAgAEACQBgCYBgC4BgDBBgUiLADwP9AG9S_aBhYKEAkRGQFwEAAYAOAGAfIGAggAgAcBiAcAoAcByAey2AXSBw8VZAEmECAA2gcGAV_w_hgA4AcA6gcCCADwB_maAYoIwgEKvQEAAAGVHly0-At_TuHyWlekBSbXDsn7MA9kiN8zpQ3JU8nyaO8zDdp7eXakZns5iCya3WWSR84RbuXAFW3-XwQJeVDN6TyG7YPNRXX4XdmMcWX9_1-QRFJpDfa-JbkkC7fYcZAqd8ZtVFwqslqguelw0STCq4BqBFk4FzPd-AeWHANk_mkOfwp6MpZue28Vux_gDUVUgG02dxjB3K6zennqYPc7saGU_2WRWY3DmLT5qRojJ63yZx_ce2dwxwsQAZUIAACAP5gIAcAIANIIDgiBgoSIkKDAgAEQABgA2ggECAAgAOAIAOgIAA..%26s%3D9e2f1bc1368ef251ec44c5d79310bc41bba2ca52;ts=1739971147;cet=0;cecb=\" width=\"0\" height=\"0\" style=\"display: block; margin: 0; padding: 0; height: 0; width: 0;\"><script type=\"text/javascript\" async=\"true\" src=\"https://cdn.adnxs.com/v/s/249/trk.js\"></script></div><div style=\"position:absolute;left:0px;top:0px;visibility:hidden;\"><img src=\"https://fra1-ib.adnxs.com/it?an_audit=0&referrer=https%253A%252F%252Fvdreiling-lab-test.s3.us-east-1.amazonaws.com%252Fprebid-presentation%252FpageWith2.html&e=wqT_3QL5DKB5BgAAAwDWAAUBCMu0170GEKSv6ZKf3NO_CxiHo-insLLStBIqNgkAAAECCPg_EQEHNAAA-D8ZAAAAwPUo-D8hERIAKREJADERG6gwsqKiBjjtSEDtSEgCUKbK-y5YnPFbYABotc95eLLYBYABAYoBA1VTRJIBAQbgmAHYBaABWqgBAbABALgBAcABBMgBAtABANgBAOABAPABAIoCKXVmKCdhJywgMjUyOTg4NSwgMCk7ARQwcicsIDk4NDkzNzM0LAEV8P2SArkEIWdHWkdOQWpLdkpvZEVLYksteTRZQUNDYzhWc3dBRGdBUUFSSTdVaFFzcUtpQmxnQVlPOEJhQUJ3SG5nZWdBRXVpQUVla0FFQm1BRUJvQUVCcUFFRHNBRUF1UUctMEV6RkFBRDRQOEVCdnRCTXhRQUEtRF9KQVh2RGw4S1c5LWtfMlFFQUFBQUFBQUR3UC1BQkFQVUJBQUFBQUpnQ0FLQUNBTFVDQUFBQUFMMENBQUFBQU1BQ0FNZ0NBTkFDQU5nQ0FPQUNBT2dDQVBnQ0FJQURBWmdEQWJvRENVWlNRVEU2TlRZNE9lQUR5MGlJQkFDUUJBQ1lCQUhCQgVNCQEIeVFRCQkBARROZ0VBUEURlSxBQUFDSUJia3NxUVUBDQmoCDdFRgEKCQEIREJCHT8AeRUoDEFBQU4yKAAAWi4oAPBlNEFYd2t3bnFCU1lJQkJJaUFBQUVHaXVpMDIwUjBQTVFldUxka0Rha19yMmI3VWFsX3MtZUlTM3FFRmx3bV9BRjdmemFBdmdGM2JTYUFZSUdBMVZUUklnR0FKQUdBWmdHQUtFR0FBAYU0QUEtRC1vQmdHeUJpUUoJEgUBAFIFBgkBAFoJBwUBAGgFBgUBGEM0QmdxQkMFDAkBSGlBZ0FrQWdBmgKVASF1QkRMX1E2PQIkblBGYklBUW9BRDFEWEQ0UHpvSlJsSkJNVG8xTmpnNVFNdElTMTUMUEFfVREMDEFBQVcdDABZHQwAYR0MAGMdDBBlQUNKQR0QeMICNWh0dHBzOi8vZG9jcy5wcmViaWQub3JnL2Rldi0BFIgvZ2V0dGluZy1zdGFydGVkLmh0bWzYAvfpA-ACrZhI6gJYaA1CFHZkcmVpbAErkGxhYi10ZXN0LnMzLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL3AFa1gtcHJlc2VudGF0aW9uL3BhZ2VXaXRoMgVlyIADAIgDAZADAJgDF6ADAaoDAMAD2ATIAwDYA76sAuADAOgDAPgDAYAEAJIEDS91dC92Mw1W8H2YBACiBAw5MS45Ni42OC4xNzioBOfJB7IEEwgEEAQY2AUgWigBKAIwADgCQgC4BADABIDauCLIBADSBA45MzI1I0ZSQTE6NTY4OdoEAggB4AQB8ASmyvsuiAUBmAUAoAX___________8BwAUAyQUAAAAAAADwP9IFCQkAAACFuXDYBQHgBQHwBZn0IfoFBAgAEACQBgCYBgC4BgDBBgUiLADwP9AG9S_aBhYKEAkRGQFwEAAYAOAGAfIGAggAgAcBiAcAoAcByAey2AXSBw8VZAEmECAA2gcGAV_w_hgA4AcA6gcCCADwB_maAYoIwgEKvQEAAAGVHly0-At_TuHyWlekBSbXDsn7MA9kiN8zpQ3JU8nyaO8zDdp7eXakZns5iCya3WWSR84RbuXAFW3-XwQJeVDN6TyG7YPNRXX4XdmMcWX9_1-QRFJpDfa-JbkkC7fYcZAqd8ZtVFwqslqguelw0STCq4BqBFk4FzPd-AeWHANk_mkOfwp6MpZue28Vux_gDUVUgG02dxjB3K6zennqYPc7saGU_2WRWY3DmLT5qRojJ63yZx_ce2dwxwsQAZUIAACAP5gIAcAIANIIDgiBgoSIkKDAgAEQABgA2ggECAAgAOAIAOgIAA..&s=c6fcf3b118918dba361b8ec2960485117d3805ae\"></div>",
  'metrics': {
    'userId.init.consent': [
      0.09999999403953552
    ],
    'userId.mod.init': [
      1.7999999821186066
    ],
    'userId.mods.liveIntentId.init': [
      1.7999999821186066
    ],
    'userId.init.modules': [
      1.9000000059604645
    ],
    'userId.callbacks.pending': [
      0
    ],
    'userId.mod.callback': [
      149.69999998807907
    ],
    'userId.mods.liveIntentId.callback': [
      149.69999998807907
    ],
    'userId.callbacks.total': [
      149.80000001192093
    ],
    'userId.total': [
      152.90000000596046
    ],
    'requestBids.userId': 147.2999999821186,
    'requestBids.validate': 0.30000001192092896,
    'requestBids.makeRequests': 0.699999988079071,
    'requestBids.total': 215.7999999821186,
    'requestBids.callBids': 65,
    'adapter.client.validate': 0,
    'adapters.client.appnexus.validate': 0,
    'adapter.client.buildRequests': 1.199999988079071,
    'adapters.client.appnexus.buildRequests': 1.199999988079071,
    'adapter.client.total': 62.69999998807907,
    'adapters.client.appnexus.total': 62.69999998807907,
    'adapter.client.net': 59.5,
    'adapters.client.appnexus.net': 59.5,
    'adapter.client.interpretResponse': 0.5,
    'adapters.client.appnexus.interpretResponse': 0.5,
    'addBidResponse.validate': 0.09999999403953552,
    'addBidResponse.total': 0.9000000059604645,
    'render.deferred': null,
    'render.pending': 130.60000002384186,
    'render.e2e': 346.40000000596046,
    'adserver.pending': 130.80000001192093,
    'adserver.e2e': 346.59999999403954
  },
  'adapterCode': 'appnexus',
  'originalCpm': 1.5,
  'originalCurrency': 'USD',
  'deferBilling': false,
  'deferRendering': false,
  'responseTimestamp': 1739971147806,
  'requestTimestamp': 1739971147744,
  'bidder': 'appnexus',
  'timeToRespond': 62,
  'pbLg': '1.50',
  'pbMg': '1.50',
  'pbHg': '1.50',
  'pbAg': '1.50',
  'pbDg': '1.50',
  'pbCg': '',
  'size': '728x90',
  'adserverTargeting': {
    'hb_bidder': 'appnexus',
    'hb_adid': '4e02072b881823',
    'hb_pb': '1.50',
    'hb_size': '728x90',
    'hb_source': 'client',
    'hb_format': 'banner',
    'hb_adomain': '',
    'hb_crid': 98493734
  },
  'latestTargetedAuctionId': 'a8ac8297-9f6f-4e35-bb42-8405ea908e92',
  'status': 'rendered',
  'params': [
    {
      'placementId': 13144370
    }
  ]
}

export const BID_WON_EVENT_UNDEFINED = {
  'bidderCode': undefined,
  'width': 728,
  'height': 90,
  'statusMessage': 'Bid available',
  'adId': '4e02072b881823',
  'requestId': '3fae2718fd70f',
  'transactionId': '6daa1dac-9eea-47ce-82ce-ce9681df1ec5',
  'adUnitId': undefined,
  'auctionId': '87b4a93d-19ae-432a-96f0-8c2d4cc1c539',
  'mediaType': 'banner',
  'source': 'client',
  'cpm': undefined,
  'creativeId': 98493734,
  'currency': undefined,
  'netRevenue': true,
  'ttl': 300,
  'adUnitCode': undefined,
  'appnexus': {
    'buyerMemberId': 9325
  },
  'meta': {
    'advertiserId': 2529885,
    'dchain': {
      'ver': '1.0',
      'complete': 0,
      'nodes': [
        {
          'bsid': '9325'
        }
      ]
    },
    'brandId': 555545
  },
  'ad': "<!-- Creative 98493734 served by Member 9325 via AppNexus --><a href=\"https://fra1-ib.adnxs.com/click2?e=wqT_3QKfAfBtnwAAAAMAxBkFAQjLtNe9BhCkr-mSn9zTvwsYh6Pop7Cy0rQSILKiogYo7Ugw7Ug4AkCmyvsuSJzxW1AAWgNVU0RiA1VTRGjYBXBaeLXPeYABstgFiAEBkAEBmAEDoAECqQEAAAAAAAD4P7EBAAABDDD4P7kBAAAAwPUo-D_BAQoAAAEeAMkVCjDYAQDgAQDwAfUv-AEA/s=6676f8c324bf37b4366612bef92c11edbe7356f1/bcr=AAAAAAAA8D8=/cnd=%21uBDL_QjKvJodEKbK-y4YnPFbIAQoADEAAAAAAAD4PzoJRlJBMTo1Njg5QMtISQAAAAAAAPA_UQAAAAAAAAAAWQAAAAAAAAAAYQAAAAAAAAAAaQAAAAAAAAAAcQAAAAAAAAAAeACJAQAAAAAAAAAA/cca=OTMyNSNGUkExOjU2ODk=/bn=93234/clickenc=https%3A%2F%2Fdocs.prebid.org%2Fdev-docs%2Fgetting-started.html\" target=\"_blank\"><img width=\"728\" height=\"90\" style=\"border-style: none\" src=\"https://vcdn.adnxs.com/p/creative-image/f6/11/33/19/f6113319-e789-4408-b69d-b178d60c5a6e.png\" /></a><iframe src=\"https://acdn.adnxs.com/dmp/async_usersync.html?gdpr=0&seller_id=9325&pub_id=1193043\" width=\"1\" height=\"1\" frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" topmargin=\"0\" leftmargin=\"0\" style=\"position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0;\"></iframe><script>try {!function(){function e(e,t){return\"function\"==typeof __an_obj_extend_thunk?__an_obj_extend_thunk(e,t):e}function t(e,t){\"function\"==typeof __an_err_thunk&&__an_err_thunk(e,t)}function n(e,t){if(\"function\"==typeof __an_redirect_thunk)__an_redirect_thunk(e);else{var n=navigator.connection;navigator.__an_connection&&(n=navigator.__an_connection),window==window.top&&n&&n.downlinkMax<=.115&&\"function\"==typeof HTMLIFrameElement&&HTMLIFrameElement.prototype.hasOwnProperty(\"srcdoc\")?(window.__an_resize=function(e,t,n){var r=e.frameElement;r&&\"__an_if\"==r.getAttribute(\"name\")&&(t&&(r.style.width=t+\"px\"),n&&(r.style.height=n+\"px\"))},document.write('<iframe name=\"__an_if\" style=\"width:0;height:0\" srcdoc=\"<script type=\\'text/javascript\\' src=\\''+e+\"&\"+t.bdfif+\"=1'></sc\"),document.write('ript>\" frameborder=\"0\" scrolling=\"no\" marginheight=0 marginwidth=0 topmargin=\"0\" leftmargin=\"0\" allowtransparency=\"true\"></iframe>')):document.write('<script language=\"javascript\" src=\"'+e+'\"></scr'+'ipt>')}};var r=function(e){this.rdParams=e};r.prototype={constructor:r,walkAncestors:function(e){try{if(!window.location.ancestorOrigins)return;for(var t=0,n=window.location.ancestorOrigins.length;n>t;t++)e.call(null,window.location.ancestorOrigins[t],t)}catch(r){\"undefined\"!=typeof console}return[]},walkUpWindows:function(e){var t,n=[];do try{t=t?t.parent:window,e.call(null,t,n)}catch(r){return\"undefined\"!=typeof console,n.push({referrer:null,location:null,isTop:!1}),n}while(t!=window.top);return n},getPubUrlStack:function(e){var n,r=[],o=null,i=null,a=null,c=null,d=null,s=null,u=null;for(n=e.length-1;n>=0;n--){try{a=e[n].location}catch(l){\"undefined\"!=typeof console,t(l,\"AnRDModule::getPubUrlStack:: location\")}if(a)i=encodeURIComponent(a),r.push(i),u||(u=i);else if(0!==n){c=e[n-1];try{d=c.referrer,s=c.ancestor}catch(l){\"undefined\"!=typeof console,t(l,\"AnRDModule::getPubUrlStack:: prevFrame\")}d?(i=encodeURIComponent(d),r.push(i),u||(u=i)):s?(i=encodeURIComponent(s),r.push(i),u||(u=i)):r.push(o)}else r.push(o)}return{stack:r,detectUrl:u}},getLevels:function(){var e=this.walkUpWindows(function(e,n){try{n.push({referrer:e.document.referrer||null,location:e.location.href||null,isTop:e==window.top})}catch(r){n.push({referrer:null,location:null,isTop:e==window.top}),\"undefined\"!=typeof console,t(r,\"AnRDModule::getLevels\")}});return this.walkAncestors(function(t,n){e[n].ancestor=t}),e},getRefererInfo:function(){var e=\"\";try{var n=this.getLevels(),r=n.length-1,o=null!==n[r].location||r>0&&null!==n[r-1].referrer,i=this.getPubUrlStack(n);e=this.rdParams.rdRef+\"=\"+i.detectUrl+\"&\"+this.rdParams.rdTop+\"=\"+o+\"&\"+this.rdParams.rdIfs+\"=\"+r+\"&\"+this.rdParams.rdStk+\"=\"+i.stack+\"&\"+decodeURI(this.rdParams.rdQs)}catch(a){e=\"\",\"undefined\"!=typeof console,t(a,\"AnRDModule::getRefererInfo\")}return e}};var o=function(n){var o=\"\";try{n=e(n,0);var i=e(new r(n),1);return i.getRefererInfo()}catch(a){o=\"\",\"undefined\"!=typeof console,t(a,\"AnRDModule::executeRD\")}return o};;var c=\"https://fra1-ib.adnxs.com/rd_log?an_audit=0&referrer=https%3A%2F%2Fvdreiling-lab-test.s3.us-east-1.amazonaws.com%2Fprebid-presentation%2FpageWith2.html&e=wqT_3QL4DqB4BwAAAwDWAAUBCMu0170GEKSv6ZKf3NO_CxiHo-insLLStBIqNgkAAAECCPg_EQEHNAAA-D8ZAAAAwPUo-D8hERIAKREJADERG6gwsqKiBjjtSEDtSEgCUKbK-y5YnPFbYABotc95eLLYBYABAYoBA1VTRJIBAQbgmAHYBaABWqgBAbABALgBAcABA8gBAtABANgBAOABAPABAIoCKXVmKCdhJywgMjUyOTg4NSwgMCk7ARQwcicsIDk4NDkzNzM0LAEV8P2SArkEIWdHWkdOQWpLdkpvZEVLYksteTRZQUNDYzhWc3dBRGdBUUFSSTdVaFFzcUtpQmxnQVlPOEJhQUJ3SG5nZWdBRXVpQUVla0FFQm1BRUJvQUVCcUFFRHNBRUF1UUctMEV6RkFBRDRQOEVCdnRCTXhRQUEtRF9KQVh2RGw4S1c5LWtfMlFFQUFBQUFBQUR3UC1BQkFQVUJBQUFBQUpnQ0FLQUNBTFVDQUFBQUFMMENBQUFBQU1BQ0FNZ0NBTkFDQU5nQ0FPQUNBT2dDQVBnQ0FJQURBWmdEQWJvRENVWlNRVEU2TlRZNE9lQUR5MGlJQkFDUUJBQ1lCQUhCQgVNCQEIeVFRCQkBARROZ0VBUEURlSxBQUFDSUJia3NxUVUBDQmoCDdFRgEKCQEIREJCHT8AeRUoDEFBQU4yKAAAWi4oAPBlNEFYd2t3bnFCU1lJQkJJaUFBQUVHaXVpMDIwUjBQTVFldUxka0Rha19yMmI3VWFsX3MtZUlTM3FFRmx3bV9BRjdmemFBdmdGM2JTYUFZSUdBMVZUUklnR0FKQUdBWmdHQUtFR0FBAYU0QUEtRC1vQmdHeUJpUUoJEgUBAFIFBgkBAFoJBwUBAGgFBgUBGEM0QmdxQkMFDAkBSGlBZ0FrQWdBmgKVASF1QkRMX1E2PQIkblBGYklBUW9BRDFEWEQ0UHpvSlJsSkJNVG8xTmpnNVFNdElTMTUMUEFfVREMDEFBQVcdDABZHQwAYR0MAGMdDBBlQUNKQR0QeMICNWh0dHBzOi8vZG9jcy5wcmViaWQub3JnL2Rldi0BFIgvZ2V0dGluZy1zdGFydGVkLmh0bWzYAvfpA-ACrZhI6gJYaA1CFHZkcmVpbAErkGxhYi10ZXN0LnMzLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL3AFa1gtcHJlc2VudGF0aW9uL3BhZ2VXaXRoMgVlMPICEQoGQURWX0lEEgdtoQUUCENQRwUUFDU2ODQ4NAUUCAVDUAETNAg2MTI1MTE0NvICDgoIATxoRlJFURICMjPyAg0KCFJFTV9VU0VSEgEw8gIMCSEUQ09ERRIABQ8BWBEPEAsKB0NQFQ4QCQoFSU8BYQQA8gEaBElPFRo4EwoPQ1VTVE9NX01PREVMDSQIGgoWMhYAHExFQUZfTkFNBWoIHgoaNh0ACEFTVAE-EElGSUVEAWIcDQoIU1BMSVQBTdABMIADAIgDAZADAJgDF6ADAaoDAMAD2ATIAwDYA76sAuADAOgDAPgDAYAEAJIEDS91dC92My1d8H2YBACiBAw5MS45Ni42OC4xNzioBOfJB7IEEwgEEAQY2AUgWigBKAIwADgCQgC4BADABIDauCLIBADSBA45MzI1I0ZSQTE6NTY4OdoEAggB4AQB8ASmyvsuiAUBmAUAoAX___________8BwAUAyQUAAAAAAADwP9IFCQkAAAClwHDYBQHgBQHwBZn0IfoFBAgAEACQBgCYBgC4BgDBBgUiLADwP9AG9S_aBhYKEAkRGQFwEAAYAOAGAfIGAggAgAcBiAcAoAcByAey2AXSBw8VZAEmECAA2gcGAV_w9hgA4AcA6gcCCADwB_maAYoIwgEKvQEAAAGVHly0-At_TuHyWlekBSbXDsn7MA9kiN8zpQ3JU8nyaO8zDdp7eXakZns5iCya3WWSR84RbuXAFW3-XwQJeVDN6TyG7YPNRXX4XdmMcWX9_1-QRFJpDfa-JbkkC7fYcZAqd8ZtVFwqslqguelw0STCq4BqBFk4FzPd-AeWHANk_mkOfwp6MpZue28Vux_gDUVUgG02dxjB3K6zennqYPc7saGU_2WRWY3DmLT5qRojJ63yZx_ce2dwxwsQAZUIAACAP5gIAcAIANIIBggAEAAYANoIBAgAIADgCADoCAA.&s=85d0e398f1a637f01e83f3a42d8ad7d3bf45b8ac\";c+=\"&\"+o({rdRef:\"bdref\",rdTop:\"bdtop\",rdIfs:\"bdifs\",rdStk:\"bstk\",rdQs:\"\"}),n(c,{bdfif:\"bdfif\"})}();} catch (e) { }</script><div name=\"anxv\" lnttag=\"v;tv=view7-1hs;st=0;d=728x90;vc=iab;vid_ccr=1;tag_id=13144370;cb=https%3A%2F%2Ffra1-ib.adnxs.com%2Fvevent%3Fan_audit%3D0%26referrer%3Dhttps%253A%252F%252Fvdreiling-lab-test.s3.us-east-1.amazonaws.com%252Fprebid-presentation%252FpageWith2.html%26e%3DwqT_3QL5DKB5BgAAAwDWAAUBCMu0170GEKSv6ZKf3NO_CxiHo-insLLStBIqNgkAAAECCPg_EQEHNAAA-D8ZAAAAwPUo-D8hERIAKREJADERG6gwsqKiBjjtSEDtSEgCUKbK-y5YnPFbYABotc95eLLYBYABAYoBA1VTRJIBAQbgmAHYBaABWqgBAbABALgBAcABA8gBAtABANgBAOABAPABAIoCKXVmKCdhJywgMjUyOTg4NSwgMCk7ARQwcicsIDk4NDkzNzM0LAEV8P2SArkEIWdHWkdOQWpLdkpvZEVLYksteTRZQUNDYzhWc3dBRGdBUUFSSTdVaFFzcUtpQmxnQVlPOEJhQUJ3SG5nZWdBRXVpQUVla0FFQm1BRUJvQUVCcUFFRHNBRUF1UUctMEV6RkFBRDRQOEVCdnRCTXhRQUEtRF9KQVh2RGw4S1c5LWtfMlFFQUFBQUFBQUR3UC1BQkFQVUJBQUFBQUpnQ0FLQUNBTFVDQUFBQUFMMENBQUFBQU1BQ0FNZ0NBTkFDQU5nQ0FPQUNBT2dDQVBnQ0FJQURBWmdEQWJvRENVWlNRVEU2TlRZNE9lQUR5MGlJQkFDUUJBQ1lCQUhCQgVNCQEIeVFRCQkBARROZ0VBUEURlSxBQUFDSUJia3NxUVUBDQmoCDdFRgEKCQEIREJCHT8AeRUoDEFBQU4yKAAAWi4oAPBlNEFYd2t3bnFCU1lJQkJJaUFBQUVHaXVpMDIwUjBQTVFldUxka0Rha19yMmI3VWFsX3MtZUlTM3FFRmx3bV9BRjdmemFBdmdGM2JTYUFZSUdBMVZUUklnR0FKQUdBWmdHQUtFR0FBAYU0QUEtRC1vQmdHeUJpUUoJEgUBAFIFBgkBAFoJBwUBAGgFBgUBGEM0QmdxQkMFDAkBSGlBZ0FrQWdBmgKVASF1QkRMX1E2PQIkblBGYklBUW9BRDFEWEQ0UHpvSlJsSkJNVG8xTmpnNVFNdElTMTUMUEFfVREMDEFBQVcdDABZHQwAYR0MAGMdDBBlQUNKQR0QeMICNWh0dHBzOi8vZG9jcy5wcmViaWQub3JnL2Rldi0BFIgvZ2V0dGluZy1zdGFydGVkLmh0bWzYAvfpA-ACrZhI6gJYaA1CFHZkcmVpbAErkGxhYi10ZXN0LnMzLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL3AFa1gtcHJlc2VudGF0aW9uL3BhZ2VXaXRoMgVlyIADAIgDAZADAJgDF6ADAaoDAMAD2ATIAwDYA76sAuADAOgDAPgDAYAEAJIEDS91dC92Mw1W8H2YBACiBAw5MS45Ni42OC4xNzioBOfJB7IEEwgEEAQY2AUgWigBKAIwADgCQgC4BADABIDauCLIBADSBA45MzI1I0ZSQTE6NTY4OdoEAggB4AQB8ASmyvsuiAUBmAUAoAX___________8BwAUAyQUAAAAAAADwP9IFCQkAAACFuXDYBQHgBQHwBZn0IfoFBAgAEACQBgCYBgC4BgDBBgUiLADwP9AG9S_aBhYKEAkRGQFwEAAYAOAGAfIGAggAgAcBiAcAoAcByAey2AXSBw8VZAEmECAA2gcGAV_w_hgA4AcA6gcCCADwB_maAYoIwgEKvQEAAAGVHly0-At_TuHyWlekBSbXDsn7MA9kiN8zpQ3JU8nyaO8zDdp7eXakZns5iCya3WWSR84RbuXAFW3-XwQJeVDN6TyG7YPNRXX4XdmMcWX9_1-QRFJpDfa-JbkkC7fYcZAqd8ZtVFwqslqguelw0STCq4BqBFk4FzPd-AeWHANk_mkOfwp6MpZue28Vux_gDUVUgG02dxjB3K6zennqYPc7saGU_2WRWY3DmLT5qRojJ63yZx_ce2dwxwsQAZUIAACAP5gIAcAIANIIDgiBgoSIkKDAgAEQABgA2ggECAAgAOAIAOgIAA..%26s%3D9e2f1bc1368ef251ec44c5d79310bc41bba2ca52;ts=1739971147;cet=0;cecb=\" width=\"0\" height=\"0\" style=\"display: block; margin: 0; padding: 0; height: 0; width: 0;\"><script type=\"text/javascript\" async=\"true\" src=\"https://cdn.adnxs.com/v/s/249/trk.js\"></script></div><div style=\"position:absolute;left:0px;top:0px;visibility:hidden;\"><img src=\"https://fra1-ib.adnxs.com/it?an_audit=0&referrer=https%253A%252F%252Fvdreiling-lab-test.s3.us-east-1.amazonaws.com%252Fprebid-presentation%252FpageWith2.html&e=wqT_3QL5DKB5BgAAAwDWAAUBCMu0170GEKSv6ZKf3NO_CxiHo-insLLStBIqNgkAAAECCPg_EQEHNAAA-D8ZAAAAwPUo-D8hERIAKREJADERG6gwsqKiBjjtSEDtSEgCUKbK-y5YnPFbYABotc95eLLYBYABAYoBA1VTRJIBAQbgmAHYBaABWqgBAbABALgBAcABBMgBAtABANgBAOABAPABAIoCKXVmKCdhJywgMjUyOTg4NSwgMCk7ARQwcicsIDk4NDkzNzM0LAEV8P2SArkEIWdHWkdOQWpLdkpvZEVLYksteTRZQUNDYzhWc3dBRGdBUUFSSTdVaFFzcUtpQmxnQVlPOEJhQUJ3SG5nZWdBRXVpQUVla0FFQm1BRUJvQUVCcUFFRHNBRUF1UUctMEV6RkFBRDRQOEVCdnRCTXhRQUEtRF9KQVh2RGw4S1c5LWtfMlFFQUFBQUFBQUR3UC1BQkFQVUJBQUFBQUpnQ0FLQUNBTFVDQUFBQUFMMENBQUFBQU1BQ0FNZ0NBTkFDQU5nQ0FPQUNBT2dDQVBnQ0FJQURBWmdEQWJvRENVWlNRVEU2TlRZNE9lQUR5MGlJQkFDUUJBQ1lCQUhCQgVNCQEIeVFRCQkBARROZ0VBUEURlSxBQUFDSUJia3NxUVUBDQmoCDdFRgEKCQEIREJCHT8AeRUoDEFBQU4yKAAAWi4oAPBlNEFYd2t3bnFCU1lJQkJJaUFBQUVHaXVpMDIwUjBQTVFldUxka0Rha19yMmI3VWFsX3MtZUlTM3FFRmx3bV9BRjdmemFBdmdGM2JTYUFZSUdBMVZUUklnR0FKQUdBWmdHQUtFR0FBAYU0QUEtRC1vQmdHeUJpUUoJEgUBAFIFBgkBAFoJBwUBAGgFBgUBGEM0QmdxQkMFDAkBSGlBZ0FrQWdBmgKVASF1QkRMX1E2PQIkblBGYklBUW9BRDFEWEQ0UHpvSlJsSkJNVG8xTmpnNVFNdElTMTUMUEFfVREMDEFBQVcdDABZHQwAYR0MAGMdDBBlQUNKQR0QeMICNWh0dHBzOi8vZG9jcy5wcmViaWQub3JnL2Rldi0BFIgvZ2V0dGluZy1zdGFydGVkLmh0bWzYAvfpA-ACrZhI6gJYaA1CFHZkcmVpbAErkGxhYi10ZXN0LnMzLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL3AFa1gtcHJlc2VudGF0aW9uL3BhZ2VXaXRoMgVlyIADAIgDAZADAJgDF6ADAaoDAMAD2ATIAwDYA76sAuADAOgDAPgDAYAEAJIEDS91dC92Mw1W8H2YBACiBAw5MS45Ni42OC4xNzioBOfJB7IEEwgEEAQY2AUgWigBKAIwADgCQgC4BADABIDauCLIBADSBA45MzI1I0ZSQTE6NTY4OdoEAggB4AQB8ASmyvsuiAUBmAUAoAX___________8BwAUAyQUAAAAAAADwP9IFCQkAAACFuXDYBQHgBQHwBZn0IfoFBAgAEACQBgCYBgC4BgDBBgUiLADwP9AG9S_aBhYKEAkRGQFwEAAYAOAGAfIGAggAgAcBiAcAoAcByAey2AXSBw8VZAEmECAA2gcGAV_w_hgA4AcA6gcCCADwB_maAYoIwgEKvQEAAAGVHly0-At_TuHyWlekBSbXDsn7MA9kiN8zpQ3JU8nyaO8zDdp7eXakZns5iCya3WWSR84RbuXAFW3-XwQJeVDN6TyG7YPNRXX4XdmMcWX9_1-QRFJpDfa-JbkkC7fYcZAqd8ZtVFwqslqguelw0STCq4BqBFk4FzPd-AeWHANk_mkOfwp6MpZue28Vux_gDUVUgG02dxjB3K6zennqYPc7saGU_2WRWY3DmLT5qRojJ63yZx_ce2dwxwsQAZUIAACAP5gIAcAIANIIDgiBgoSIkKDAgAEQABgA2ggECAAgAOAIAOgIAA..&s=c6fcf3b118918dba361b8ec2960485117d3805ae\"></div>",
  'metrics': {
    'userId.init.consent': [
      0.09999999403953552
    ],
    'userId.mod.init': [
      1.7999999821186066
    ],
    'userId.mods.liveIntentId.init': [
      1.7999999821186066
    ],
    'userId.init.modules': [
      1.9000000059604645
    ],
    'userId.callbacks.pending': [
      0
    ],
    'userId.mod.callback': [
      149.69999998807907
    ],
    'userId.mods.liveIntentId.callback': [
      149.69999998807907
    ],
    'userId.callbacks.total': [
      149.80000001192093
    ],
    'userId.total': [
      152.90000000596046
    ],
    'requestBids.userId': 147.2999999821186,
    'requestBids.validate': 0.30000001192092896,
    'requestBids.makeRequests': 0.699999988079071,
    'requestBids.total': 215.7999999821186,
    'requestBids.callBids': 65,
    'adapter.client.validate': 0,
    'adapters.client.appnexus.validate': 0,
    'adapter.client.buildRequests': 1.199999988079071,
    'adapters.client.appnexus.buildRequests': 1.199999988079071,
    'adapter.client.total': 62.69999998807907,
    'adapters.client.appnexus.total': 62.69999998807907,
    'adapter.client.net': 59.5,
    'adapters.client.appnexus.net': 59.5,
    'adapter.client.interpretResponse': 0.5,
    'adapters.client.appnexus.interpretResponse': 0.5,
    'addBidResponse.validate': 0.09999999403953552,
    'addBidResponse.total': 0.9000000059604645,
    'render.deferred': null,
    'render.pending': 130.60000002384186,
    'render.e2e': 346.40000000596046,
    'adserver.pending': 130.80000001192093,
    'adserver.e2e': 346.59999999403954
  },
  'adapterCode': 'appnexus',
  'originalCpm': 1.5,
  'originalCurrency': 'USD',
  'deferBilling': false,
  'deferRendering': false,
  'responseTimestamp': undefined,
  'requestTimestamp': undefined,
  'bidder': undefined,
  'timeToRespond': 62,
  'pbLg': '1.50',
  'pbMg': '1.50',
  'pbHg': '1.50',
  'pbAg': '1.50',
  'pbDg': '1.50',
  'pbCg': '',
  'size': '728x90',
  'adserverTargeting': {
    'hb_bidder': 'appnexus',
    'hb_adid': '4e02072b881823',
    'hb_pb': '1.50',
    'hb_size': '728x90',
    'hb_source': 'client',
    'hb_format': 'banner',
    'hb_adomain': '',
    'hb_crid': 98493734
  },
  'latestTargetedAuctionId': 'a8ac8297-9f6f-4e35-bb42-8405ea908e92',
  'status': 'rendered',
  'params': [
    {
      'placementId': 13144370
    }
  ]
}
